import _ from "lodash";
import {
  searchPatientsService,
  createPatientService,
  trackPatientService,
  trackAppointmentService,
  updateTrackAppointmentService,
  getReferredSpecialistsService,
  checkPatientService,
} from "../../services/workflow";
import { transformTrackedAppointment } from "../../utils";

export const searchPatients = async (searchText) => {
  try {
    const result = await searchPatientsService({ searchText });
    return { hasError: false, patients: _.get(result, "data", []) };
  } catch (e) {
    return {
      hasError: true,
      errorText: "Search patients failed!",
    };
  }
};

export const getReferredSpecialists = async ({ clientId }) => {
  try {
    const result = await getReferredSpecialistsService({ clientId });
    return { hasError: false, referredSpecialists: _.get(result, "data.referredSpecialists", []) };
  } catch (e) {
    return {
      hasError: true,
      errorText: "Loading referred specialists failed. Please try again.",
      referredSpecialists: [],
    };
  }
};

export const checkPatient = async ({ clientId }) => {
  try {
    const appointments = await checkPatientService({ clientId });
    return { hasError: false, appointments };
  } catch (e) {
    return {
      hasError: true,
      errorText: "Checking patient failed",
      appointments: null,
    };
  }
};

export const trackCoreplusPatient = async ({ clientId }) => {
  try {
    await trackPatientService({ clientId });
    return { hasError: false };
  } catch (e) {
    const errorStatus = _.get(e, "response.status");
    const errorText =
      errorStatus === 400
        ? "Tracking patient failed. Please check if this patient has a valid referral."
        : "Tracking patient failed";
    return { hasError: true, errorText };
  }
};

export const trackPatient = async ({ clientId, referralId }) => {
  try {
    await trackPatientService({ clientId, referralId });
    return { hasError: false };
  } catch (e) {
    const errorStatus = _.get(e, "response.status");
    const errorText =
      errorStatus === 400 ? _.get(e, "response.data.error", "Tracking patient failed") : "Tracking patient failed";

    return { hasError: true, errorText };
  }
};

export const createPatient = async ({ firstName, lastName, dateOfBirth }, dispatch) => {
  dispatch({
    type: "SET_LOADING",
    payload: {
      isLoading: true,
      loadingText: "creating a coreplus patient ...",
    },
  });

  try {
    await createPatientService({ firstName, lastName, dateOfBirth });
  } catch (e) {
    dispatch({
      type: "SET_ERROR",
      payload: {
        hasError: true,
        errorText: "Creating a coreplus patient failed",
      },
    });
  } finally {
    dispatch({
      type: "SET_LOADING",
      payload: {
        isLoading: false,
        loadingText: "",
      },
    });
  }
};

export const trackAppointment = async ({ appointmentId, secretCode }, dispatch) => {
  dispatch({ type: "SET_IS_VERIFYING", payload: { isVerifying: true } });
  try {
    const result = await trackAppointmentService({ appointmentId, secretCode });
    const appointment = _.get(result, "data", null);
    dispatch({ type: "SET_APPOINTMENT", payload: { appointment: transformTrackedAppointment(appointment) } });
  } catch (error) {
    dispatch({ type: "SET_VERIFY_ERROR", payload: { verifyError: true } });
  } finally {
    dispatch({ type: "SET_IS_VERIFYING", payload: { isVerifying: false } });
  }
};

export const updateTrackAppointment = async (
  { id, secret, nextSession, itemNumber, isLetterReady, testRequired, notes },
  appState,
  dispatch
) => {
  appState.submittingError && dispatch({ type: "SET_SUBMITTING_ERROR", payload: { submittingError: false } });
  appState.submittingMessage && dispatch({ type: "SET_SUBMITTING_MESSAGE", payload: { submittingMessage: "" } });
  dispatch({ type: "SET_IS_SUBMITTING", payload: { isSubmitting: true } });
  try {
    await updateTrackAppointmentService({
      id,
      secret,
      nextSession,
      itemNumber,
      isLetterReady,
      testRequired,
      notes,
    });
    dispatch({ type: "SET_SUBMITTING_MESSAGE", payload: { submittingMessage: "SUCCESS" } });
  } catch (error) {
    dispatch({ type: "SET_SUBMITTING_ERROR", payload: { submittingError: true } });
    dispatch({ type: "SET_SUBMITTING_MESSAGE", payload: { submittingMessage: "FAILED" } });
  } finally {
    dispatch({ type: "SET_IS_SUBMITTING", payload: { isSubmitting: false } });
  }
};
